
import {Component, Vue} from 'vue-property-decorator'

@Component
export default class InfoLayout extends Vue {
    get showAlert(): boolean {
        return this.$store.state.msg !== ''
    }
}
